"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = require("prop-types");
var _default = exports["default"] = (0, _propTypes.shape)({
  loop: _propTypes.bool,
  isPlaying: _propTypes.bool,
  volume: _propTypes.number,
  muted: _propTypes.bool,
  seek: _propTypes.number
});